<template>
<el-container>
     <el-main v-if="invoices">
      <el-row type="flex" justify="space-start" :gutter="30">

        <!-- Create New -->

        <el-col :span="24">
          <el-card class="box-card">
            <div class="card-header">
              <h4 class="card-title">Invoices to Pay</h4>
            </div>
            <div class="card-content">
        <data-tables-server 
                  class="table-shopping" 
                  style="width: 100%" 
                  :data="invoices" 
                  :tool-bar="false" 
                  :current-page="1" 
                  :total="total"
                  :loading="loadingInvoices"
                  :page-size="10"
            
                  :pagination-props="{ pageSizes: [5, 10, 15, 20, 50] }">

                  <el-table-column label="Date Created" min-width="10">
                    <template slot-scope="props" v-if="props.row.dateCreated != ''">{{props.row.dateCreated | moment('DD/MM/YYYY')}}</template>
                  </el-table-column>
                  <el-table-column label="ID" min-width="5">
                    <template slot-scope="props">{{props.row.id}}</template>
                  </el-table-column>

                  <el-table-column label="Tutor" min-width="10">
                    <template slot-scope="props" >{{props.row.tutor.firstname}} {{props.row.tutor.lastname}}</template>
                  </el-table-column>
                   <el-table-column label="ID" min-width="10">
                    <template slot-scope="props">{{props.row.invoiceDate | moment('DD/MM/YYYY')}}</template>
                  </el-table-column>
                  <el-table-column label="Classroom Total" min-width="8">
                    <template slot-scope="props" >{{props.row.classRoomTotal | currentyCodeToSymbol(props.row.tutor.currency)}}</template>
                  </el-table-column>

                  <el-table-column label="Bonus Total" min-width="8">
                    <template slot-scope="props" >{{props.row.bonusTotal | currentyCodeToSymbol(props.row.tutor.currency)}}</template>
                  </el-table-column>

                  <el-table-column label="Invoice Total" min-width="10">
                    <template slot-scope="props" >{{props.row.invoiceTotal | currentyCodeToSymbol(props.row.tutor.currency)}}</template>
                  </el-table-column>

                  


             

                  <el-table-column label="View" min-width="10">
                    <template slot-scope="props" v-if="props.row.sourceUrl != ''"><a :href="props.row.sourceUrl" :target="'_blank'"><i class="fa fa-download"></i></a></template>
                  </el-table-column>

                  <el-table-column label="Paid" min-width="10">
                    <template slot-scope="props"><el-checkbox v-model="props.row.isPaid" @change="saveInvoice(props.row.id,props.row.isPaid)" :checked="props.row.isPaid==1?true:false"></el-checkbox></template>
                  </el-table-column>
                </data-tables-server>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </el-main>
    </el-container>
</template>
<script>
import gql from "graphql-tag";
import moment from "moment"
export default{
    data(){
        return {
invoices:[],
 total: 0,
 loadingInvoices:false

        }
    },
    methods:{
getOutstandingInvoices(){
    //get all the Tutor invoices where paid is false
    let q =gql`
    query getUnpaidInvoices {
  TutorInvoice(where: {isPaid: {_eq: "0"}}) {
    dateCreated
    isPaid
    sourceUrl
    tutor {
      currency
      firstname
      lastname
      email
    }
    invoiceTotal
    invoiceDate
    classRoomTotal
    bonusTotal
    id
    paidDate
  }
}
    `;
    this.$apollo
      .query({query:q}) .then(response => {
        this.invoices = response.data.TutorInvoice;
      
      });
},
saveInvoice(id,state){
  let q=gql`
mutation invoiceUpdate($id:Int!,$isPaid:smallint!) {
  update_TutorInvoice(where: {id: {_eq: $id}}, _set: {isPaid: $isPaid,paidDate:"${moment().format()}"}) {
    affected_rows
  }
}
  `
  state=state=true?1:0;
  console.log(state)
  this.$apollo
      .mutate({mutation:q,variables:{id:id,isPaid:state}}).then(response => {
       // this.invoices = response.data.TutorInvoice;
        this.$notify({
                title: "Saved",
                message: "Invoice Paid",
                type: "success"
              })
      });
}
    },
    
  mounted() {
    this.getOutstandingInvoices()
  },

}
</script>



// WEBPACK FOOTER //
// src/components/Classrooms/Invoice.vue